import { gql } from '@apollo/client'

export const ENABLE_RANKING_FOR_COMPANY_COUNTRY = gql`
  mutation EnableRankingSeasonForCompanyCountry($companyId: HashedId!, $country: Country!) {
    enableRankingSeasonForCompanyCountry(companyId: $companyId, country: $country)
  }
`

export const SAVE_RANKING = gql`
  mutation SaveRanking($companyId: HashedId!, $talentsSeasonId: HashedId!, $ranks: [RankInput!]!) {
    saveRanking(companyId: $companyId, talentsSeasonId: $talentsSeasonId, ranks: $ranks)
  }
`

export const DISABLE_RANKING_FOR_COMPANY_COUNTRY = gql`
  mutation DisableRankingSeasonForCompanyCountry($companyId: HashedId!, $country: Country!) {
    disableRankingSeasonForCompanyCountry(companyId: $companyId, country: $country)
  }
`

export const UPDATE_RANKING_SEASON = gql`
  mutation UpdateRankingSeason($talentsSeasonInput: TalentsSeasonInput!) {
    updateRankingSeason(talentsSeasonInput: $talentsSeasonInput)
  }
`

export const CONFIRM_RANKING_SEASON = gql`
  mutation ConfirmRankingSeason($talentsSeasonId: HashedId!) {
    confirmRankingSeason(talentsSeasonId: $talentsSeasonId)
  }
`
